import { observer } from "mobx-react";
import React, { Component } from "react";
import { MainStore } from "../../stores/MainStore";
import Label from "../Label";
import CountryModalBody from "./CountryModalBody";
import CountryModalHeader from "./CountryModalHeader";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
}
interface IState {}
@observer
class CountryModal extends Component<IProps, IState> {
  render() {
    const { store } = this.props;
    const { selectedState } = store;
    if (!selectedState) return null;
    return (
      <div className={classes.CountryModal}>
        <CountryModalHeader store={store} />
        <CountryModalBody store={store} />
        {/* <CountryModalFooter store={store} /> */}
        <div
          onClick={e => {
            store.selectState(selectedState);
          }}
        >
          <Label
            uppercase
            bold
            extraSmall
            id={"generic.close"}
            className={classes.CountryModalClose}
          />
        </div>
      </div>
    );
  }
}
export default CountryModal;
